 <template>
    <v-layout justify-center>
        <v-responsive max-width="1440" width="100%">
            <list-heading v-model="showSearch" title="작가 목록" />
            <v-data-table :items="items" :headers="headers" hide-default-footer disable-sort class="my-4">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                <div slot="item.thumb" slot-scope="{ value }" class="py-4">
                    <image-popup :src="value?.url" size="48" />
                </div>
                <template v-slot:[`item.actions`]="{ item }">
                    <author-view :value="item" @input="update">
                        <template #activator="{ attrs, on }">
                            <v-btn v-bind="attrs" v-on="on" text icon color="primary" large><v-icon>mdi-pencil</v-icon></v-btn>
                        </template>
                    </author-view>
                    <v-btn icon text color="red" @click="remove(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>

            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="my-4" @input="search()" />
            <author-view @input="update">
                <template #activator="{ attrs, on }">
                    <v-btn v-bind="attrs" v-on="on" fab fixed right bottom color="primary" large><v-icon>mdi-pencil</v-icon></v-btn>
                </template>
            </author-view>
        </v-responsive>
    </v-layout>
</template>

<script>
import ImagePopup from "@/components/console/dumb/image-popup.vue";
import ListHeading from "@/components/console/dumb/list-heading.vue";
import AuthorView from "@/components/console/auction/author-view.vue";

import api from "@/api";

const formatter_dateTime = (value) => value?.toDateTime?.() || "-";
const formatter_date = (value) => value?.toDate?.() || "-";

const headers = [
    { text: "번호", value: "index", width: 70 },
    { text: "국가(국문)", value: "country.ko" },
    { text: "국가(영문)", value: "country.en" },
    { text: "이름(국문)", value: "name.ko" },
    { text: "이름(영문)", value: "name.en" },
    { text: "생년월일", value: "bornAt", width: 110, formatter: formatter_date },
    { text: "생몰월일", value: "diedAt", width: 110, formatter: formatter_date },
    { text: "작성일", value: "createdAt", width: 110, formatter: formatter_dateTime },
    { text: "", value: "actions", width: 140, align: "right" },
];

export default {
    components: {
        ImagePopup,
        ListHeading,
        AuthorView,
    },
    data() {
        return {
            ///////////////////////////////////////////////
            // 검색필터
            ///////////////////////////////////////////////
            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
            },

            page: +this.$route.query.page || 1,
            totalCount: 0,
            limit: 10,

            authors: [],
            headers,
        };
    },
    computed: {
        pageCount() {
            return Math.ceil(this.totalCount / this.limit);
        },
        items() {
            return (this.authors || []).map((item, index) => ({ ...item, index: +this.totalCount - (+this.page - 1) * +this.limit - index }));
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        $route() {
            this.search(false);

            Object.assign(this.filter, this.$route.query);
            this.page = +this.$route.query.page || 1;
        },
    },
    methods: {
        init() {
            this.search(false);
        },
        manualSearch() {
            this.page = 1;
            this.search();
        },
        async search(routable = true) {
            if (routable) this.$router.push({ query: Object.assign({}, this.filter, { page: this.page }) });

            var {
                summary: { totalCount },
                authors,
            } = await api.console.auction.authors.gets({
                headers: { skip: (this.page - 1) * this.limit, limit: this.limit },
                params: this.filter,
            });

            this.authors = authors;
            this.totalCount = totalCount;
        },
        async remove(item) {
            if (!confirm(`작가를 삭제하시겠습니까?\n\n제목:    "${item?.subject || ""}"\n작성일: ${item?.createdAt?.toDateTime()}`)) return;

            await api.console.auction.authors.delete(item);
            this.authors = this.authors.filter((content) => content._id !== item._id);
            alert("작가가 삭제되었습니다.");
        },
        async update(item) {
            const index = this.authors.findIndex(({ _id }) => _id == item._id);
            if (index > -1) this.authors.splice(index, 1, item);
            else this.authors = [item, ...this.authors];
        },
    },
};
</script>
